import { AxiosError } from "axios";
import { BundleDetachErrorEnum } from "../../enums/BundleDetachErrorEnum";
import { coreApiErrorResponseSchema } from "./schema/coreDetachRoomElementsSchema";

/** The body CoreAPI's detach endpoint takes. */
export interface DetachRoomElementsBody {
    roomElementIds: number[];
    targetRoomId: number | null;    // Null for an apartment-level bundle. Always sent: leaving it out keeps the original's placement.
    newBundleOverwriteProps?: { name: string };  // Without it CoreAPI names the copy "‹original› (New)"
}

export type BundleDetachResult =
    | { ok: true; newBundleId: number }
    | { ok: false; error: BundleDetachErrorEnum };

// CoreAPI answers both of these with a 404 and tells them apart only in devMessage (bundleRoomElementsData.detachRoomElements)
const DIFFERENT_APARTMENT_MESSAGE = 'does not belong to the same apartment';
const SEVERAL_BUNDLES_MESSAGE = 'more than one bundle';

// hasTargetRoom: a 400 then means the room isn't in the project (bundleRoutes.detachRoomElementsFromBundle)
export const bundleDetachErrorFromApiError = (error: unknown, hasTargetRoom: boolean): BundleDetachErrorEnum => {
    if (!(error instanceof AxiosError)) return BundleDetachErrorEnum.Failed;

    const status = error.response?.status;
    if (status === 403) return BundleDetachErrorEnum.Forbidden;

    const parsed = coreApiErrorResponseSchema.safeParse(error.response?.data);
    const devMessage = parsed.success ? parsed.data.error?.devMessage ?? '' : '';
    if (devMessage.includes(DIFFERENT_APARTMENT_MESSAGE)) return BundleDetachErrorEnum.DifferentApartment;
    if (devMessage.includes(SEVERAL_BUNDLES_MESSAGE)) return BundleDetachErrorEnum.SeveralBundles;
    if (status === 400 && hasTargetRoom) return BundleDetachErrorEnum.DifferentApartment;
    return BundleDetachErrorEnum.Failed;
};
